module.exports = __webpack_public_path__ + "static/media/DSC01402 - Version 2.7a03b445.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/DSC01402 - Version 2.jpg
// module id = 508
// module chunks = 0